import { ComponentGlobals } from "../ComponentGlobals";
var removeAllChildren = function (node) {
    var r = [];
    while (node.childNodes.length > 0) {
        r.push(node.removeChild(node.childNodes.item(0)));
    }
    return r;
};
var shrinkChildren = function (node, count) {
    while (node.childNodes.length > count) {
        node.removeChild(node.childNodes.item(node.childNodes.length - 1));
    }
};
var setSingleChild = function (node, content) {
    if (node.childNodes.length === 0) {
        node.appendChild(content);
    }
    else if (node.childNodes.item(0) !== content) {
        node.replaceChild(content, node.childNodes.item(0));
    }
};
var dispatchWindowResizeImmediate = function () {
    ComponentGlobals.ignoreResize = true;
    try {
        var event = document.createEvent("Event");
        event.initEvent("resize", true, true);
        window.dispatchEvent(event);
    }
    finally {
        ComponentGlobals.ignoreResize = false;
    }
};
var dispatchWindowResize = function () {
    // may need to debounce this in the future
    dispatchWindowResizeImmediate();
};
export { removeAllChildren, shrinkChildren, setSingleChild, dispatchWindowResize };
